import React, { useState, useEffect, useRef } from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import { Button } from "primereact/button";
import {
  createIncidentType,
  updateIncidentType,
  getIncidentType,
  Question,
  Document
} from "../../service/incidentTypeService";
import { Grid } from "@mui/material";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Textarea } from "@mui/joy";
import {FileUpload} from "primereact/fileupload";
import {s3UploadFile} from "../../service/s3Service";
import { v4 as uuid } from 'uuid';
import {downloadFile} from "../../service/documentsService";
import { Checkbox } from 'primereact/checkbox';

export default function IncidentTypeAdd(modalProps: any) {
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState(false);
  const [description, setDescription] = useState("");
  const [questions, setQuestions] = useState<Question[]>([]);

  const [documents, setDocuments] = useState<Document[]>([]);
  const fileNewDocumentRef = useRef<FileUpload>(null);
  const [newDocumentName, setNewDocumentName] = useState("");
  const [newDocuments, setNewDocuments] = useState<{ name: string, file: File}[]>([]);

  useEffect(() => {

    const fetchIncidentType = async () => {

      if (modalProps.id)
      {
        modalProps.setGlobalLoading(true);
        try {
          const response = await getIncidentType(modalProps.id);
          console.log("response == ", response);
          setName(response.content.name);
          setDescription(response.content.description);
          setQuestions(response.content.questions);
          setDocuments(response.content.documents);
        } catch (error) {
          modalProps.toast.current.show({
            severity: "error",
            summary: "Error fetching incident type details",
            life: 3000,
          });
        }
        modalProps.setGlobalLoading(false);
      }
    };

    fetchIncidentType();
  }, [modalProps.id]);

  async function saveIncidentType() {
    setNameError(!name || name === "");
    if (!name || name === "") {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please enter all required fields",
        life: 3000,
      });
      return;
    }

    // Filter out empty questions
    const filteredQuestions = questions
      .filter((q: any) => typeof q === 'string' ? q.trim() !== '' : q.question.trim() !== '')
      .map((q: any) => typeof q === 'string' ? { question: q } : q);

    try
    {
      modalProps.setGlobalLoading(true);
      const uploadedDocs = [];
      for(const doc of newDocuments) {
        const key = `incident-type/${modalProps.id}/documents/${uuid()}/${doc.file.name}`;
        await s3UploadFile(key, doc.file);
        uploadedDocs.push({ name: doc.name, s3_key: key });
      }

      const updateDetails = {
        name,
        description,
        questions: filteredQuestions,
        documents: [...documents, ...uploadedDocs]
      };

      if (modalProps.id)
      {
        await updateIncidentType(modalProps.id, updateDetails);
        modalProps.toast.current.show({
          severity: "success",
          summary: "Incident Type Updated Successfully",
          life: 3000,
        });
      }
      else
      {
        await createIncidentType(updateDetails);
        modalProps.toast.current.show({
          severity: "success",
          summary: "Incident Type Created Successfully",
          life: 3000,
        });
      }
      modalProps.setVisible(false);
      modalProps.setGlobalLoading(false);
      modalProps.setReload(!modalProps.reload);
    }
    catch (error)
    {
      modalProps.toast.current.show({
        severity: "error",
        summary: "Error saving incident type",
        life: 3000,
      });
    }
  }

  const customBase64Uploader = async (event: any) => {
    const uploadedFile = event.files[0] as File;
    if (uploadedFile) {
      setNewDocuments([...newDocuments, { name: newDocumentName, file: uploadedFile }]);
      setNewDocumentName("");
      fileNewDocumentRef.current!.clear();
    }
  }

  const download = async (s3Key: string) => {
    await downloadFile("", s3Key);
  }

  return (
    <React.Fragment>
      <TabView>
        <TabPanel header="Incident">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl error={nameError} sx={{ display: { sm: "flex-column", md: "flex-row" }, width: "100%" }}>
                <FormLabel> Name<div style={{ color: "red" }}>*</div> </FormLabel>
                <Input value={name} size="sm" placeholder="Incident Type Name"
                  onChange={(e) => setName(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, width: "100%" }}>
                <FormLabel>Description</FormLabel>
                <Textarea minRows={3} value={description} placeholder="Enter description"
                  onChange={(e) => setDescription(e.target.value)}
                />
              </FormControl>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel header="Questions">
          {/*<Grid container spacing={2}>*/}
          {/*  <Grid item xs={12}>*/}
          {/*    <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>*/}
          {/*      <Button type="button" icon="pi pi-plus" label="Add" className="p-button-outlined"*/}
          {/*        style={{  position: "absolute",  right: 0, padding: 10,  marginTop: -15 }} size="small"*/}
          {/*        onClick={() => {*/}
          {/*          const updatedQuestions = [...questions];*/}
          {/*          updatedQuestions.push({ question: "" });*/}
          {/*          setQuestions(updatedQuestions);*/}
          {/*        }}*/}
          {/*      />*/}
          {/*    </FormControl>*/}
          {/*  </Grid>*/}

          <div style={{display: "grid", gridTemplateColumns: "80px 1fr", gap: 10}}>
            <div style={{fontWeight: "bold"}}>Required</div>
            <div style={{fontWeight: "bold"}}>Question</div>


            {questions.map((q: any, index: number) => {
              const questionText = typeof q === 'string' ? q : q.question;
              return (
                <>
                  <Checkbox inputId={"check" + index}
                            onChange={(e) => {
                              console.log("e.target.value == ", e);
                              const updatedQuestions = [...questions];
                              updatedQuestions[index] = {
                                ...q,
                                required: e.checked || false
                              };
                              setQuestions(updatedQuestions);
                            }}
                            checked={!!q.required}
                            style={{marginTop: 15, marginLeft: 25}}/>
                  <Grid item xs={12} key={index} style={{marginTop: 10}}>
                    <IconField>
                      <InputIcon className="pi pi-trash" style={{color: "#eb445a"}}
                                 onClick={() => {
                                   const updatedQuestions = [...questions];
                                   updatedQuestions.splice(index, 1);
                                   setQuestions(updatedQuestions);
                                 }}
                      >
                        {" "}
                      </InputIcon>
                      <InputText value={questionText} style={{width: "100%"}} type="text"
                                 className="p-inputtext-sm PrimeSmallInput"
                                 placeholder={`Please enter question ${index + 1}`}
                                 onChange={(e) => {
                                   const updatedQuestions = [...questions];
                                   updatedQuestions[index] = {
                                     ...q,
                                     question: e.target.value
                                   };
                                   setQuestions(updatedQuestions);
                                 }}
                      />
                    </IconField>
                  </Grid>
                </>

              );
            })}

          </div>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControl>
                  <Button type="button" icon="pi pi-plus" label="Add" className="p-button-outlined"
                          size="small" style={{marginTop: 30, maxWidth: 100, padding: "5px 10px"}}
                          onClick={() => {
                            const updatedQuestions = [...questions];
                            updatedQuestions.push({question: ""});
                            setQuestions(updatedQuestions);
                          }}
                  />
                </FormControl>
              </Grid>
            </Grid>
        </TabPanel>

        <TabPanel header="Documents">
          {documents.map((d: any, index: number) => {
            return (
              <Grid item xs={12} key={index}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <span className="document-download-link" style={{flexGrow: 1 }}
                        onClick={() => download(d.s3_key)}>
                    {d.name} ({d.s3_key.slice(d.s3_key.lastIndexOf('/')).slice(1)})
                  </span>
                  <Button icon="pi pi-trash" rounded outlined severity="danger" aria-label="Cancel" text size="small"
                          onClick={() => {
                            setDocuments(documents.filter((_, i) => i !== index));
                          }}/>
                </div>
              </Grid>
            );
          })}
          {newDocuments.map((d: any, index: number) => {
            return (
              <Grid item xs={12} key={index}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <span style={{flexGrow: 1}}>{d.name}</span>
                  <Button icon="pi pi-trash" rounded outlined severity="danger" aria-label="Cancel" text size="small"
                          onClick={() => {
                            setNewDocuments(newDocuments.filter((_, i) => i !== index));
                          }}/>
                </div>
              </Grid>
            );
          })}
          <Grid container spacing={2} style={{marginTop: 10}}>
            <div className="flex gap-3 p-fluid">
              {/*<span style={{fontSize: "large"}}>New Document</span>*/}
              <div className="flex-auto">
                <FormControl sx={{display: {sm: "flex-column", md: "flex-row"}}}>
                  <InputText placeholder="New Document Name" value={newDocumentName}
                             className="p-inputtext-sm PrimeSmallInput" style={{marginLeft: 15}}
                             onChange={(e) => setNewDocumentName(e.target.value)}/>
                </FormControl>
              </div>
              <div className="flex-auto">
                <FormControl sx={{display: {sm: 'flex-column', md: 'flex-row'}, gap: 2}}>
                  <FileUpload ref={fileNewDocumentRef} mode="basic" className="PrimeSmallFileUpload" style={{marginLeft: 5}}
                              accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
                              auto customUpload chooseLabel="Select Document" uploadHandler={customBase64Uploader}
                              disabled={!newDocumentName.length}/>
                </FormControl>
              </div>
            </div>
          </Grid>
        </TabPanel>

      </TabView>
      <br/>
      <br/>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            name="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => saveIncidentType()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
